import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@drdropin-tech/theseus';
// This should be moved to a custom input component and handled
// within the input component itself
export default function InputError({ isDirty, errors }) {
    return (_jsxs(_Fragment, { children: [isDirty && !errors && (_jsx("div", { className: "absolute inset-y-0 right-5 flex items-center", children: _jsx(Icon, { name: "CheckCircle", appearance: "primary", className: "animated-checkmark" }) })), errors && (_jsx("div", { className: "absolute inset-y-0 right-5 flex items-center", children: _jsx(Icon, { name: "AlertOctagon", className: "stroke-error" }) }))] }));
}
